/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/* Storage */
import { selectCarouselsListByCarouselInfoList } from '../storage/carousels';

/* Utils */
import { pickCarouselInfoList } from '../utils/pageCarouselList';

export default function usePageCarousels(page, filtered = false) {
  const carouselInfoList = useMemo(() => pickCarouselInfoList(page), [page]);
  const selector = useMemo(
    () => selectCarouselsListByCarouselInfoList(carouselInfoList, filtered),
    [carouselInfoList, filtered],
  );
  return useSelector(selector);
}
